import FormTemplate from "@/modules/FormTemplate/FormTemplate.vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "@/modules/Home/Home.vue";
import List from "@/modules/List/List.vue";
import Vue from "vue";
import Login from "@/modules/Login/Login.vue";
import store from "@/store";
import { RolesGuard } from "./guards/roles.guard";
import { HomeGuard } from "./guards/menu.guard";
import InfoGroup from "../modules/InfoGroup/InfoGroup.vue";
import UserTemplate from "../modules/UserTemplate/UserTemplate.vue";
import Roles from "@/modules/Roles/Roles.vue";
import User from "../modules/User/User.vue";
import ServiceTemplate from "../modules/ServiceTemplate/ServiceTemplate.vue";
import SessionTemplate from "@/modules/SessionTemplate/SessionTemplate.vue";
import Space from "@/modules/Space/Space.vue";
import SaveSpace from "@/modules/Space/components/SaveSpace/SaveSpace.vue";
import CupsPriceLevels from "@/modules/CupsPriceLevels/CupsPriceLevels.vue";
import SaveOrderField from "@/modules/Orders/components/SaveOrderField/SaveOrderField.vue";
import Profile from "@/modules/Profile/Profile.vue";
import MedicalOrder from "@/modules/MedicalOrder/MedicalOrder.vue";
import LoadOrders from "@/modules/MedicalOrder/components/LoadOrders/LoadOrders.vue";
import ViewIntelliticks from "@/modules/WebViews/GroupTypeService/components/ViewIntelliticks/ViewIntelliticks.vue";
import AdminDashboard from "@/modules/Dashboards/AdminDashboard/AdminDashboard.vue";
import Campus from "@/modules/Campus/Campus.vue";
import SaveCampus from "@/modules/Campus/components/SaveCampus/SaveCampus.vue";
import Dependencies from "../modules/Dependencies/Dependencies.vue";
import SaveDependencies from "../modules/Dependencies/components/SaveDependencies/SaveDependencies.vue";
import Availability from "../modules/Availability/Availability.vue";
import DoctorProfile from "@/modules/DoctorProfile/DoctorProfile.vue";
import Register from "@/modules/Login/Register/Register.vue";
import NotificationTemplate from "@/modules/NotificationTemplate/NotificationTemplate.vue";
import GeneralRules from "@/modules/GeneralRules/GeneralRules.vue";
import TemplatePdf from "@/modules/TemplatePdf/TemplatePdf.vue";
import PrincipalDashboard from "@/modules/Dashboards/PrincipalDashboard/PrincipalDashboard.vue";
import TemplateDashboard from "@/modules/Dashboards/TemplateDashboard/TemplateDashboard.vue";
import Multimedia from "@/modules/Multimedia/Multimedia.vue";
import ActionPlan from "@/modules/ActionPlan/ActionPlan.vue";
import LoadDocument from "@/modules/WebViews/LoadDocument/LoadDocument.vue";
import { IntelliticksGuard } from "./guards/intelliticks.guard";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    component: Home,
    meta: {
      requiresAuth: true
    },
    beforeEnter: HomeGuard,
    children: [
      {
        path: "/",
        name: "Home",
        component: PrincipalDashboard,
        beforeEnter: RolesGuard
      },
      {
        path: "/templates",
        name: "Templates",
        component: TemplateDashboard,
        beforeEnter: RolesGuard
      },
      {
        path: "/form-templates",
        name: "FormTemplate",
        component: FormTemplate,
        beforeEnter: RolesGuard,
        meta: {
          id: "formTemplate"
        }
      },
      {
        path: "/lists/:id?",
        name: "List",
        component: List,
        beforeEnter: RolesGuard,
        meta: {
          id: "list"
        }
      },
      {
        path: "/info-group",
        name: "InfoGroup",
        component: InfoGroup,
        beforeEnter: RolesGuard,
        meta: {
          id: "infoGroup"
        }
      },
      {
        path: "/user-templates",
        name: "UserTemplate",
        component: UserTemplate,
        beforeEnter: RolesGuard,
        meta: {
          id: "userTemplate"
        }
      },
      {
        path: "/users/:userDocument?/:userId?",
        name: "User",
        component: User,
        beforeEnter: RolesGuard,
        meta: {
          id: "user"
        }
      },
      {
        path: "/roles",
        name: "Roles",
        component: Roles,
        beforeEnter: RolesGuard,
        meta: {
          id: "roles"
        }
      },
      {
        path: "/service-templates",
        name: "ServicesTemplate",
        component: ServiceTemplate,
        beforeEnter: RolesGuard,
        meta: {
          id: "serviceTemplates"
        }
      },
      {
        path: "/session-templates",
        name: "SessionTemplates",
        component: SessionTemplate,
        beforeEnter: RolesGuard,
        meta: {
          id: "sessionTemplates"
        }
      },
      {
        path: "/price-levels",
        name: "CupsPriceLevel",
        component: CupsPriceLevels,
        beforeEnter: RolesGuard,
        meta: {
          id: "cupsPriceLevels"
        }
      },
      {
        path: "/space",
        name: "Space",
        component: Space,
        beforeEnter: RolesGuard,
        meta: {
          id: "space"
        }
      },
      {
        path: "/save-space/:id?",
        name: "SaveSpace",
        component: SaveSpace,
        beforeEnter: RolesGuard,
        meta: {
          id: "saveSpace"
        }
      },
      {
        path: "/profile/:id?/:service?",
        name: "Profile",
        component: Profile,
        beforeEnter: RolesGuard,
        meta: {
          id: "patientProfile"
        }
      },
      {
        path: "/save-order-template",
        name: "SaveOrderTemplate",
        component: SaveOrderField,
        beforeEnter: RolesGuard,
        meta: {
          id: "saveOrderTemplate"
        }
      },
      {
        path: "/save-medical-order",
        name: "MedicalOrder",
        component: MedicalOrder,
        beforeEnter: RolesGuard,
        meta: {
          id: "saveMedicalOrder"
        }
      },
      {
        path: "/load-orders",
        name: "LoadOrders",
        component: LoadOrders,
        beforeEnter: RolesGuard,
        meta: {
          id: "saveMedicalOrder"
        }
      },
      {
        path: "/admin-dashboard",
        name: "AdminDashboard",
        component: AdminDashboard,
        beforeEnter: RolesGuard,
        meta: {
          id: "adminDashboard"
        }
      },
      {
        path: "/campus",
        name: "Campus",
        component: Campus,
        beforeEnter: RolesGuard,
        meta: {
          id: "campus"
        }
      },
      {
        path: "/save-campus/:id?",
        name: "SaveCampus",
        component: SaveCampus,
        beforeEnter: RolesGuard,
        meta: {
          id: "saveCampus"
        }
      },
      {
        path: "/dependencies",
        name: "Dependencies",
        component: Dependencies,
        beforeEnter: RolesGuard,
        meta: {
          id: "dependencies"
        }
      },
      {
        path: "/save-dependencies/:id?",
        name: "SaveDependencies",
        component: SaveDependencies,
        beforeEnter: RolesGuard,
        meta: {
          id: "saveDependencies"
        }
      },
      {
        path: "/availability/",
        name: "Availability",
        component: Availability,
        beforeEnter: RolesGuard,
        meta: {
          id: "availability"
        }
      },
      {
        path: "/doctor-profile/:id?",
        name: "DoctorProfile",
        component: DoctorProfile,
        beforeEnter: RolesGuard,
        meta: {
          id: "doctorProfile"
        }
      },
      {
        path: "/notification-templates",
        name: "NotificationTemplate",
        component: NotificationTemplate,
        beforeEnter: RolesGuard,
        meta: {
          id: "notificationTemplate"
        }
      },
      {
        path: "/template-pdf",
        name: "TemplatePdf",
        component: TemplatePdf,
        beforeEnter: RolesGuard,
        meta: {
          id: "templatePdf"
        }
      },
      {
        path: "/general-rules",
        name: "GeneralRules",
        component: GeneralRules,
        beforeEnter: RolesGuard,
        meta: {
          id: "generalRules"
        }
      },
      {
        path: "/multimedia",
        name: "Multimedia",
        component: Multimedia,
        beforeEnter: RolesGuard,
        meta: {
          id: "multimedia"
        }
      },
      {
        path: "/action-plan",
        name: "ActionPlan",
        component: ActionPlan,
        beforeEnter: RolesGuard,
        meta: {
          id: "actionPlan"
        }
      }
    ]
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../modules/Home/About.vue")
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/user/:type/:info?/:userId?",
    name: "Register",
    component: Register
  },
  {
    path: "/form-intelliticks/:key",
    name: "ViewIntelliticks",
    component: ViewIntelliticks,
    beforeEnter: IntelliticksGuard
  },
  {
    path: "/load-document-intelliticks/:key",
    name: "LoadDocument",
    component: LoadDocument,
    beforeEnter: IntelliticksGuard
  },
  {
    path: "*",
    redirect: "/"
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem("TOKEN") == null) {
      store.commit("changeSession", false);
      next({
        path: "/login",
        params: { nextUrl: to.fullPath }
      });
    } else {
      store.commit("changeSession", true);
      next();
    }
  } else {
    if (to.path == "/login" && localStorage.getItem("TOKEN") != null) {
      next({ name: "Home" });
    } else {
      next();
    }
  }
});

export default router;
